import { Constants } from "../shared/constants"

export const savingAmountData = {
    title:"My Balance History ",
    category:"amount",
    totol:"2,234",
    arr:[
        {
            img: Constants.customImages.transactionAvatar1,
            name: "To Myskools",
            type:"debited"
        },
        {
            img: Constants.customImages.transactionAvatar2,
            name: "From Myskools",
            type:"credited"
        },
        {
            img: Constants.customImages.transactionAvatar3,
            name: "To Myskools",
            type:"ddebited"
        },
    ]

}
   

